import { benefitsId, collaborationId, howItWorksId } from '@/utils/sectionIds';

import type { FooterConfigType } from '@/components/organisms/Footer/Footer.types';

import { env } from '@/env.mjs';

export const FOOTER_CONFIG_RO: FooterConfigType = {
    links: [
        {
            name: 'PayPo',
            logoIsVisible: true,
            partnerLogo: {
                href: 'https://netopia-payments.com/',
                width: 84,
                height: 32,
                src: '/images/logos/netopia-logo.svg',
                alt: 'Netopia',
            },
        },
        {
            name: 'Clienți',
            menu: {
                lead: {
                    href: '/',
                },
                list: [
                    {
                        name: 'Cum funcționează?',
                        relatedSectionId: howItWorksId,
                        href: `/#${howItWorksId}`,
                        'data-test-id': 'footer-how-it-works-link',
                    },
                    {
                        name: 'Beneficii',
                        relatedSectionId: benefitsId,
                        href: `/#${benefitsId}`,
                        'data-test-id': 'footer-benefits-link',
                    },
                    {
                        name: 'Magazinele disponibile',
                        href: `/p/magazineledisponibile`,
                        'data-test-id': 'footer-available-shops-page-link',
                    },
                    {
                        name: 'Contact',
                        href: `/p/contact`,
                        'data-test-id': 'footer-contact-page-link',
                    },
                    {
                        name: 'Accesibilitate',
                        href: `/p/accesibilitate`,
                        'data-test-id': 'footer-accessibility-page-link',
                    },
                    {
                        name: 'Întrebări frecvente',
                        href: `${env.NEXT_PUBLIC_STATIC_WWW_URL_RO}/documents/intrebari-frecvente.pdf`,
                        target: '_blank',
                        'data-test-id': 'footer-intrebari-frecvente',
                    },
                ],
            },
        },
        {
            name: 'Comercianți',
            menu: {
                lead: {
                    href: '/p/comercianti/',
                },
                list: [
                    {
                        name: 'Beneficii',
                        relatedSectionId: benefitsId,
                        href: `/p/comercianti/#${benefitsId}`,
                        'data-test-id': 'footer-partners-why-worth-ref',
                    },
                    {
                        name: 'Cum funcționează?',
                        relatedSectionId: howItWorksId,
                        href: `/p/comercianti/#${howItWorksId}`,
                        'data-test-id': 'footer-partners-how-it-works-link',
                    },
                    {
                        name: 'Integrare',
                        href: `/p/comercianti/integrare`,
                        'data-test-id': 'footer-integrare-link',
                    },
                    {
                        name: 'Începe colaborarea',
                        relatedSectionId: collaborationId,
                        href: `/p/comercianti/#${collaborationId}`,
                        'data-test-id': 'footer-partners-integration-link',
                    },
                ],
            },
        },
        {
            name: 'Informații legale',
            menu: {
                list: [
                    {
                        name: 'Termeni și Condiții Servicii PayPo',
                        href: `${env.NEXT_PUBLIC_STATIC_WWW_URL_RO}/documents/Termenii_si_Conditiile_serviciilor_PayPo.pdf`,
                        target: '_blank',
                        'data-test-id':
                            'footer-termenii_si_conditiile_serviciilor_paypo-link',
                    },
                    {
                        name: 'Condiții de Utilizare PayPo',
                        href: `${env.NEXT_PUBLIC_STATIC_WWW_URL_RO}/documents/Conditii_de_utilizare_PayPo.pdf`,
                        target: '_blank',
                        'data-test-id':
                            'footer-conditii_de_utilizare_paypo-link',
                    },
                    {
                        name: 'Termenii și Condițiile Aplicației Mobile PayPo',
                        href: `${env.NEXT_PUBLIC_STATIC_WWW_URL_RO}/documents/termenii-si-conditiile-aplicatiei-mobile-paypo.pdf`,
                        target: '_blank',
                        'data-test-id':
                            'footer-termenii-si-conditiile-aplicatiei-mobile-paypo',
                    },
                    {
                        name: 'Informații cu privire la prelucrarea datelor cu caracter personal',
                        href: `${env.NEXT_PUBLIC_STATIC_WWW_URL_RO}/documents/Informare_cu_privire_la_prelucrarea_datelor.pdf`,
                        target: '_blank',
                        'data-test-id':
                            'footer-informare_cu_privire_la_prelucrarea_datelor-link',
                    },
                    {
                        name: 'Politica de confidențialitate și cookies',
                        href: `${env.NEXT_PUBLIC_STATIC_WWW_URL_RO}/documents/Politica_de_confidentialitate_si_cookies.pdf`,
                        target: '_blank',
                        'data-test-id':
                            'footer-politica_de_confidentialitate_si_cookies-link',
                    },
                    {
                        name: 'Informare prelucrare date in Biroul de credite',
                        href: `${env.NEXT_PUBLIC_STATIC_WWW_URL_RO}/documents/Informare_prelucrare_date_Biroul_de_Credit.pdf`,
                        target: '_blank',
                        'data-test-id':
                            'footer-informare_prelucrare_date_biroul_de_credit-link',
                    },
                    {
                        name: 'Acord pentru solicitarea veniturilor persoanelor fizice',
                        href: `${env.NEXT_PUBLIC_STATIC_WWW_URL_RO}/documents/Acord_pentru_solicitarea_veniturilor_persoanelor_fizice.pdf`,
                        target: '_blank',
                        'data-test-id':
                            'footer-acord_pentru_solicitarea_veniturilor_persoanelor_fizice-link',
                    },
                    {
                        name: 'Alte regulamente',
                        href: `/p/alteregulamente`,
                        'data-test-id': 'footer-alte-regulamente-link',
                    },
                    {
                        name: 'Arhiva de Termeni și Condiții',
                        href: `/p/arhiva-de-termeni-si-conditii`,
                        'data-test-id':
                            'footer-arhiva-de-termeni-si-conditii-link',
                    },
                ],
            },
        },
    ],
    footerInfo: [
        'PayPo Plăți Amânate IFN, entitate juridică română, cu sediul social în România, str. Colței”, nr 8, etaj 4, sector 3, București, înregistrată la Registrul Comerțului București sub nr. J2021019544406, cod unic de înregistrare 45199303, capital social subscris și vărsat de 5.935.289 RON, înscrisă în Registrul General al BNR sub nr. RG-PJR-41-110375, număr de telefon +40312294746, adresa de email: info@paypo.ro. PayPo Plăți Amânate IFN SA este participant al Biroul De Credit SA, date de contact DPO: email: dpo@paypo.ro.',
    ],
    footerInfoLinks: [
        {
            href: 'https://europa.eu/youreurope/business/dealing-with-customers/solving-disputes/online-dispute-resolution/indexamp_ro.htm',
            height: 44,
            width: 200,
            alt: 'ANCP-1',
            src: '/images/icons/ANCP-1.svg',
        },
        {
            href: 'https://anpc.ro/ce-este-sal/',
            height: 44,
            width: 124,
            alt: 'ANCP-2',
            src: '/images/icons/ANCP-2.svg',
        },
    ],
};
